export function getPageBackgroundColor(): string {
  return "light-dark(var(--mantine-color-gray-dark-3), var(--mantine-color-gray-dark-10))";
}

export function getMutedTextColor(): string {
  return "light-dark(var(--mantine-color-gray-6), var(--mantine-color-gray-4))";
}
